import { AvailableLoan } from '@/interfaces/loan';
import { UserState } from '@/interfaces/user';
import { AchProviders } from '@/constants/payments';

export function availableLoans(state: UserState): AvailableLoan[] {
  return state.loans;
}

export function activeLoanNumber(state: UserState): string | null {
  return state.activeLoanNumber;
}

export function achProvider(state: UserState): AchProviders | null {
  return state.ach_provider;
}

export function hasPaymentMethods(state: UserState): boolean {
  return state.has_payment_method;
}

export function isFirstLogin(state: UserState): boolean {
  return state.isFirstLogin;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function activeLoan(state: UserState, getters: any): AvailableLoan {
  return getters.availableLoans
    .find((l: AvailableLoan) => l.loan_number === getters.activeLoanNumber);
}

export function loansInCollection(state: UserState): AvailableLoan[] {
  return state.loans.filter((l: AvailableLoan) => {
    return l.collection.in_collection;
  });
}
